import { FC, Suspense, useEffect, useState } from 'react';
import {
  AssignmentMonitoringQuery,
  AssignmentMonitoringQuery$variables,
} from '../../graphQLOperations/__generated__/AssignmentMonitoringQuery.graphql';
import { PreloadedQuery, UseQueryLoaderLoadQueryOptions } from 'react-relay';
import { AssignmentMonitoringCards } from './AssignmentMonitoringCards';
import { AssignmentStudentsTable } from './AssignmentStudentsTable';
import { AssignmentItemList } from '../../models/Assignment';
import { AssignmentNotIncludedStudentsModal } from './AssignmentNotIncludedStudentsModal';

interface Props {
  loadQuery: (variables: AssignmentMonitoringQuery$variables, options: UseQueryLoaderLoadQueryOptions) => void;
  queryReference?: PreloadedQuery<AssignmentMonitoringQuery, Record<string, unknown>> | null;
  assignment: AssignmentItemList;
}

export const AssignmentContentWrapper: FC<Props> = ({ loadQuery, queryReference, assignment }) => {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    loadQuery({ assignmentId: assignment.id }, {});
  }, []);

  return (
    <>
      {queryReference && (
        <>
          <Suspense>
            <AssignmentMonitoringCards assignmentId={assignment.id} queryReference={queryReference} />
          </Suspense>
          <div className="mx-4 mt-4 flex justify-content-between">
            <h3 className="inline font-bold">Assigned Students:</h3>
            <Suspense>
              <AssignmentNotIncludedStudentsModal
                visible={visible}
                setVisible={setVisible}
                baseAssignment={assignment}
                queryReference={queryReference}
              />
            </Suspense>
          </div>

          <Suspense>
            <AssignmentStudentsTable queryReference={queryReference} classIds={assignment.classes.map(c => c.id)} />
          </Suspense>
        </>
      )}
    </>
  );
};
